module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAUhJREFUWEft1b1KxEAUxfHfWlkoCILYiIK2orWNWqhY2luIT+Ir+ATWtlYi+IHYKFhpoYiWIrZi7w5sIIRMJokL22TKzOSe/5x7btIz4tUbsb4OoHOgc+A/DiziGBP9UT7CTZuRbgswh2sEiLB+sIfLphBtAIrimWYriKYAMfHWEE0AysS/8JtrReN21AUoEw+Wb+GzkIcMYhOPqUzUAZjGfeKWMXe28VQFkQKYGozXSq5ILGytIKoAmohnfAHiFgs54JCTqBMxgDLxUHMHF4m+Lg/OzNaBKAOIiR/iJBWqwX4MYgOv+RpFgDFc9VO9XhBqIp69Wgbx3ndnDd/ZoSLAEt6GIF4FsYvzGMA4nnMj1+bmxS4F288wOfhnrOIjBhCez2Afd3io2fPUsXkc4BQvVRlIFRr6fupDNHTBYsEOoHOgc2DkDvwBt0tEIX52OhkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/04sportDesc/20up.png
// module id = EJlU
// module chunks = 0